import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  FormLabel,
  MenuItem,
  Select,
} from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { format } from "date-fns";
import { Dispatch, SetStateAction, useState } from "react";
import { useQuery } from "react-query";
import { getReceiptById } from "services/receipt";

interface IProps {
  open: boolean;
  handleClose: Dispatch<SetStateAction<void>>;
  date: Date | null;
  onSetDate: (date: Date | null) => void;
  data: any[];
}

const FindDay = ({
  open,
  handleClose,
  date: _date,
  onSetDate,
  data,
}: IProps) => {
  const onClose = () => {
    setDate(null);
    handleClose();
  };

  const onChange = (date: Date | null) => {
    setDate(date);
    refetch();
  };

  const [date, setDate] = useState<Date | null>(null);

  const existingDays = (data || [])?.map((item) => {
    return {
      day: format(item?.start, "dd/MM/yyyy"),
      id: item?.id as number,
    };
  });

  const isCurrentDayExist = date
    ? existingDays
        ?.map((item) => item?.day)
        .includes(format(date, "dd/MM/yyyy"))
    : false;

  const receiptId = date
    ? existingDays?.find((item) => item?.day === format(date, "dd/MM/yyyy"))?.id
    : null;

  const {
    data: currentReceiptsData,
    isLoading,
    isError,
    refetch,
  } = useQuery({
    queryKey: "reicpet",
    queryFn: getReceiptById(Number(receiptId)),
    enabled: isCurrentDayExist && Boolean(receiptId),
  });

  const payNow = () => {
    // console.log("Pay selected receipt");
    /**
     * Alert current receipt and missing amount and confirm payment
     */
    alert("This receipt must be paid amount recived = amount given");
  };

  const render = () => {
    if (isError) {
      return <>Error while fetching receipts</>;
    }
    if (isLoading) {
      return <>Getting receipts ...</>;
    }
    if ((currentReceiptsData?.receipts || [])?.length === 0) {
      return <>No unpaid receipts in this day</>;
    }
    return (
      <>
        <FormControl sx={{ width: "100%" }}>
          <FormLabel>Day Receipts</FormLabel>
          <Select variant="outlined" label="Container Type" sx={{ mt: 1 }}>
            {(currentReceiptsData?.receipts || []).map((item, index) => {
              return (
                <MenuItem value={item?.receipt_number} key={index}>
                  RN: {item?.receipt_number}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
      </>
    );
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Find day</DialogTitle>
      <DialogContent>
        <DialogContentText>Select specific day</DialogContentText>
        <Box component="form">
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <Box mb={2} mt={5}>
              <DatePicker
                label="Day"
                value={date}
                onChange={onChange}
                slotProps={{
                  day: (day) => {
                    const isCurrentDayExist = existingDays
                      ?.map((item) => item?.day)
                      .includes(format(day?.day, "dd/MM/yyyy"));
                    return {
                      sx: {
                        backgroundColor: isCurrentDayExist
                          ? "#18466d"
                          : "transparent",
                        color: isCurrentDayExist ? "white" : "inherit",
                        ":hover": {
                          color: "black",
                        },
                      },
                    };
                  },
                }}
              />
            </Box>
          </LocalizationProvider>
        </Box>
        <Box sx={{ width: "100%" }}>{render()}</Box>
      </DialogContent>
      <DialogActions>
        <Button color="error" onClick={onClose}>
          Cancel
        </Button>
        <Button onClick={() => payNow()}>Pay Now</Button>
        <Button onClick={() => onSetDate(date)} color="info">
          Find
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FindDay;
